














































































































































































































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import Tooltip from '@/components/rows/Tooltip.vue'
import { getAssetType } from '@/services/assets'
import { getMappingForType } from '@/store/modules/transactions/maps'
import { ParsedEVMTx } from '@/store/modules/transactions/helpers/parseEVMTxs'
import CopyText from '@/components/misc/CopyText.vue'
import { toDCM } from '@/helper'
import {
    CURRENT_SUBNET,
    DEFAULT_NETWORK_NAME,
    HAS_SUBNET,
} from '@/store/modules/network/network'

@Component({
    components: {
        Tooltip,
        CopyText,
    },

    filters: {
        getType: getMappingForType,
        getAssetType,
        toDCM,
    },
})
export default class EVMMetadata extends Vue {
    @Prop() tx!: ParsedEVMTx
    moreDetails = false

    // forTSP = false
    // created() {
    //     if (
    //         window.location.href.includes('blockchain') ||
    //         localStorage.getItem('isTSP')
    //     ) {
    //         this.forTSP = true
    //     }
    // }
    gas(value: string) {
        return toDCM(value, 18).toFixed(9)
    }
    get hasSubnet() {
        return HAS_SUBNET
    }
    get subnetName() {
        return CURRENT_SUBNET
    }
    get DEFAULT_NETWORK_NAME() {
        return DEFAULT_NETWORK_NAME
    }
    get assetsLoaded(): boolean {
        return this.$store.state.assetsLoaded
    }

    get value() {
        return this.tx.value ? toDCM(this.tx.value, 18) : 0
    }

    get date() {
        return new Date(this.tx.createdAt)
    }

    get gasPrice() {
        return this.tx.gasPrice
    }

    toggleMore() {
        this.moreDetails = !this.moreDetails
    }
}
